import {
    GET_DEPARTMENT_TYPES_BY_ID,
    GET_DEPARTMENT_TYPES_BY_ID_SUCCESS,

    GET_ALL_DEPARTMENT_TYPES,
    GET_ALL_DEPARTMENT_TYPES_SUCCESS,

    CREATE_DEPARTMENT_TYPES,
    CREATE_DEPARTMENT_TYPES_SUCCESS,

    UPDATE_DEPARTMENT_TYPES,
    UPDATE_DEPARTMENT_TYPES_SUCCESS,

    DELETE_DEPARTMENT_TYPES,
    DELETE_DEPARTMENT_TYPES_SUCCESS,

    GET_DEPARTMENT_TYPES_FAILURE,
} from "../storeTypes";

export interface DepartmentType {
    _id: string;
    name: string;
}


interface InitialState {
    loading: boolean;
    list: DepartmentType[];
    selected: DepartmentType | null;
    error: string;
}

const initialState: InitialState = {
    loading: false,
    list: [],
    selected: null,
    error: "",
};

const DepartmentTypesReducer = (state = initialState, action: any) => {
    switch (action.type) {

        /* ===================== REQUEST ===================== */
        case GET_ALL_DEPARTMENT_TYPES:
        case GET_DEPARTMENT_TYPES_BY_ID:
        case CREATE_DEPARTMENT_TYPES:
        case UPDATE_DEPARTMENT_TYPES:
        case DELETE_DEPARTMENT_TYPES:
            return {
                ...state,
                loading: true,
                error: "",
            };

        /* ===================== SUCCESS ===================== */
        case GET_ALL_DEPARTMENT_TYPES_SUCCESS:
            return {
                ...state,
                loading: false,
                list: action.payload || [],
            };

        case GET_DEPARTMENT_TYPES_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                selected: action.payload || null,
            };

        case CREATE_DEPARTMENT_TYPES_SUCCESS:
            return {
                ...state,
                loading: false,
                list: [...state.list, action.payload],
            };

        case UPDATE_DEPARTMENT_TYPES_SUCCESS:
            return {
                ...state,
                loading: false,
                list: state.list.map((dept: any) =>
                    dept._id === action.payload._id ? action.payload : dept
                ),
                selected: action.payload,
            };

        case DELETE_DEPARTMENT_TYPES_SUCCESS:
            return {
                ...state,
                loading: false,
                list: state.list.filter(
                    (dept: any) => dept._id !== action.payload
                ),
            };

        /* ===================== FAILURE ===================== */
        case GET_DEPARTMENT_TYPES_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload?.error || "Something went wrong",
            };

        default:
            return state;
    }
};

export default DepartmentTypesReducer;
